import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../theme/ISpcTheme';

export type ColorPickerClasses = 'activeColorTitle' | 'container';

const colorPickerStyles = makeStyles<ISpcTheme, ColorPickerClasses>(
  ({ palette, spacing }) => ({
    activeColorTitle: {
      color: palette.text.secondary,
      marginBottom: spacing(1),
      display: 'block',
    },
    container: {
      position: 'relative',
      top: 0,
    },
  }),
  { name: 'Common_ColorPicker' },
);

export default colorPickerStyles;
